<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="right_company_name" :class="navColor===1?'fixed_style_b':'fixed_style'" v-if="showNav">
        <div class="right_company_inside" >
          <div class="top_company_title">
            <img src="../../assets/image/index/logo.png" style="width:75%;height: auto;"/>
          </div>
          <div class="right_nav"  @mouseleave="leaveMenu()">
            <div class="right_nav_inside">
              <div class="first_menu_list" @mouseenter="enterMenu(1)" @mouseleave="leaveMenu(1)">
              <span @click="toPath('/','1')" :class="activeIndex==='1'?'active_index_style':''">首页
              </span>
                <transition name="el-zoom-in-top">
                  <div class="second_menu_list" v-if="pointIndex===1" >
                    <ul>
                      <li class="second_menu_li"><a @click="toPath('/','1',600,'intelligent_scene')" class="a_style">数据智能化应用</a></li>
                      <li class="second_menu_li"><a @click="toPath('/','1',1400,'case_display')" class="a_style">案例展示</a></li>
                      <li class="second_menu_li"><a @click="toPath('/','1',2300,'company_data')" class="a_style">企业实力数据</a></li>
                      <li class="second_menu_li"><a @click="toPath('/','1',2900,'digital_service')" class="a_style">数字化服务流程</a></li>
                      <li class="second_menu_li"><a @click="toPath('/','1',3348,'cooperative_unit')" class="a_style">合作单位</a></li>
                    </ul>
                  </div>
                </transition>
              </div>
              <div class="first_menu_list" @mouseenter="enterMenu(2)" @mouseleave="leaveMenu(1)">
            <span @click="toPath('/smartCommunity','2')" :class="activeIndex === '2'?'active_index_style':''">智慧社区
            </span>

                <transition name="el-zoom-in-top">
                  <div class="second_menu_list" v-if="pointIndex===2">
                    <ul>
                      <li class="third_menu_li"><a @click="toPath('/','2',600,'platform')" class="a_style">智慧社区数据融合平台</a></li>
                      <li class="third_menu_li"><a @click="toPath('/','2',1400,'exhibition')" class="a_style">系统平台展示</a></li>
                      <li class="third_menu_li"><a @click="toPath('/','2',2100,'system_watch')" class="a_style">智慧社区系统看点</a></li>
                      <li class="third_menu_li"><a @click="toPath('/','2',3100,'integrated_management')" class="a_style">智慧消防物联网综合管理平台</a></li>
                      <li class="third_menu_li"><a @click="toPath('/','2',3652,'function_introduction')" class="a_style">平台功能介绍</a></li>
                    </ul>
                  </div>
                </transition>
              </div>

              <div class="first_menu_list" @mouseenter="enterMenu(3)" @mouseleave="leaveMenu(1)">
            <span @click="toPath('/bigData','3')" :class="activeIndex ==='3'?'active_index_style':''">BIG DATA
            </span>
                <transition name="el-zoom-in-top">
                  <div class="second_menu_list" v-if="pointIndex===3">
                    <ul>
                      <li class="third_menu_li"><a @click="toPath('/','3',600,'achievements')" class="a_style">乐榜数据成果</a></li>
                      <li class="third_menu_li"><a @click="toPath('/','3',1300,'characteristic')" class="a_style">乐榜BIG DATA数据特点</a></li>
                      <li class="third_menu_li"><a @click="toPath('/','3',1900,'advantage')" class="a_style">乐榜BIG DATA数据优势</a></li>
                    </ul>
                  </div>
                </transition>
              </div>

              <div class="first_menu_list" @mouseenter="enterMenu(4)" @mouseleave="leaveMenu(1)">
              <span @click="toPath('/companyIntroduce','4')" :class="activeIndex==='4'?'active_index_style':''">关于我们</span>
                <transition name="el-zoom-in-top">
                  <div class="second_menu_list" v-if="pointIndex===4">
                    <ul>
                      <li class="second_menu_li"><a @click="toPath('/','4',600,'brief_introduction')" class="a_style">公司介绍</a>
                      </li>
                      <li class="second_menu_li"><a @click="toPath('/','4',1400,'culture')" class="a_style">企业文化</a></li>
                      <li class="second_menu_li"><a @click="toPath('/','4',1934,'qualifications')" class="a_style">资质证书</a></li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "rightHead",
  data() {
    return {
      mouseIndex: 'out',
      pointIndex: 0,
      secondArrow: 'out',
      pointSecondIndex: 0,
      scrollTop: 0,
      showTop:0
    }
  },
  props: {
    activeIndex: {
      type: String
    },
    showNav:{
      type:Boolean
    },
    navColor:{
      type:Number
    }
  },
  methods: {
    enterMenu(index) {
      this.pointIndex = index;
    },
    leaveMenu() {
      this.pointIndex = 0;
    },
    toPath(path, key,position,id) {
      let that = this;
      let active = sessionStorage.getItem('active');
      sessionStorage.setItem('active', key);
      let router=this.$route.path;
        if(path!==router){
          that.$router.push(path);
          document.documentElement.scrollTop=0;
          document.body.scrollTop = 0;
          window.pageYOffset = 0;
        }
        if(id!==undefined){
          setTimeout(()=>{
            let height=document.getElementById(id).offsetTop;
            let nowHeight=document.documentElement.scrollTop;
            let time=setInterval(()=>{
              if(nowHeight>height){
                nowHeight-=((nowHeight-height)/10);
                if(nowHeight<height || (nowHeight-height)<10){
                  nowHeight=height;
                  clearInterval(time);
                }
              }else{
                nowHeight+=((height-nowHeight)/10);
                if(nowHeight>height || (height-nowHeight)<10){
                  nowHeight=height;
                  clearInterval(time);
                }
              }
              document.documentElement.scrollTop=nowHeight;
              document.body.scrollTop = nowHeight;
              window.pageYOffset = nowHeight;
            },10)
          },400)

        }

    }
  }
}
</script>

<style scoped>

.right_company_name {
  width: 100%;
  height: 5rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  background: transparent;
}
.fixed_style{
  background: #3271FF;
}
.right_company_inside{
  width: 75%;
  height: 5rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fixed_style_b{
  transition: background 0.8s;
  -webkit-transition: background 0.8s;
}
.top_company_title {
  /*width: 49%;*/
  height: 5rem;
  line-height: 4.5rem;
  text-align: center;
  letter-spacing: 5px;
  color: white;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right_nav {
  width: 51%;
  height: 4.5rem;
  display: flex;
  /*justify-content: center;*/
  align-items: center;
  justify-content: end;
}

.right_nav_inside {
  /*width: 50%;*/
  height: 3rem;
  display: flex;
  line-height: 3rem;
  font-size: 16px;
  font-weight: 400;
  z-index: 11;
}

.first_menu_list:nth-of-type(1) {
  margin: 0 20px 9px 0;
}

.first_menu_list {
  /*width: 100px;*/
  height: 3rem;
  color: #FFFFFF;
  font-size: 18px;
  cursor: pointer;
  font-weight: 500;
  margin: 0 20px 9px;
  position: relative;
  text-align: center;
  z-index: 11;
  display: flex;
  justify-content: center;
}
.first_menu_list:last-child{
  margin-right: 0;
  /*padding: 0 0 9px;*/
}

.second_menu_list {
  min-height: 2rem;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  margin-top:45px;
  padding-top: 35px;
  text-align: center;
  position: absolute;
}

.second_menu_list > ul {
  width: auto;
  padding: 5px 18px;
  display: inline-table;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 10px 0 rgba(57, 68, 96, 0.1);
}

.second_menu_li {
  height: 2rem;
  list-style: none;
  line-height: 2rem;
  color: #353636;
  position: relative;
}

.second_menu_li:hover, .third_menu_li:hover, .active_secondary_style {
  color: #F19100;
}

.second_menu_li:hover > a, .third_menu_li:hover > a {
  color: #F19100;
  font-weight: 600;
}

.second_menu_li a, .third_menu_li a {
  font-weight: 500;
  font-size: 15px;
  display: inherit;
  white-space: nowrap;
}

.third_menu_list {
  width: 100%;
  min-height: 2rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 100%;
}

.third_menu_li {
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  font-weight: 400;
  list-style: none;
  color: #353636;
}


.a_style {
  text-decoration: none;
  color: #353636;
}

.active_index_style {
  font-weight: 600;
  /*padding: 10px 0;*/
  border-bottom: 2px solid white;
}

.first_menu_list:before {
  content: "";
  width: 2px;
  height: 0;
  background: #fff;
  margin: 0 auto;
  position: absolute;
  bottom: -35px;
  left: 50%;
  transition: all 0.5s ease 0s;
}

.first_menu_list:hover:before {
  height: 25px;
}

.first_menu_list:after {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  margin: 0 auto;
  position: absolute;
  bottom: -10px;
  left: calc(50% - 4px);
  opacity: 0;
  transition: all 0.5s ease 0s;
}

.first_menu_list:hover:after {
  /*bottom: 0px;*/
  opacity: 1;
}


@media (min-width: 1200px) {

}

@media (min-width: 979px) and (max-width: 1200px) {
  .top_company_title {
    width: 47%;
  }

  .right_nav {
    width: 100%;
  }

  /*.right_nav_inside {*/
  /*  width: 70%;*/
  /*}*/
}

/* 平板电脑和小屏电脑之间的分辨率 */
@media (min-width: 768px) and (max-width: 979px) {
  .top_company_title {
    width: 35%;
    font-size: 20px;
  }
 .first_menu_list{
   font-size: 15px;
 }
  .right_nav {
    width: 65%;
  }

  .right_nav_inside {
    width: 100%;
  }
}

/* 横向放置的手机和竖向放置的平板之间的分辨率 */
@media (max-width: 767px) {
  .top_company_title {
    width: 35%;
    height: 5.5rem;
    line-height: 5.5rem;
    text-align: center;
    color: white;
    font-size: 1rem;
  }

  .right_nav {
    width: 98%;
    height: 5.5rem;
    display: flex;
    justify-content: center;
  }

  .right_nav_inside {
    width: 98%;
    font-size: 16px;
  }
  .first_menu_list{
    font-size: 15px;
  }
  .second_menu_list {
    font-size: 12px;
  }

  .third_menu_list {
    width: 100%;
    min-height: 2rem;
    display: flex;
    flex-direction: column;
    position: absolute;
    /*top: 64px;*/
    /*left: 0;*/
    top: 0;
    left: 100%;
  }

  .third_menu_li {
    width: 13rem;
    padding: 0 5px;
    height: 2rem;
    line-height: 2rem;
    font-size: 12px;
    font-weight: 400;
    list-style: none;
    color: #FFFFFF;
  }
}

/* 横向放置的手机及分辨率更小的设备 */
@media (max-width: 480px) {
  .right_nav {
    width: 214px;
    height: 100%;
    background-color: #FFFFFF;
    z-index: 99;
    position: absolute;
    top: 0;
    left: 0;
  }

  .top_company_title {
    width: 90%;
    font-size: 1rem;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/common/rightHead.vue